export const MINIMUM_PHOTOS_TAIL_COUNT = 4

export const LIMIT_PHOTOS = 15
export const CARDS_STACK_COUNT = 2
export const ROLLBACK_RATING_BUTTON = 'rollback-rating-button-id'

export enum RatingErrorLimit {
  limit = 'limit_exceeded',
  vip_limit = 'vip_limit_exceeded',
}
